import UpdateProfilePhoto from "./UpdateProfilePhoto";
export default UpdateProfilePhoto;
